import React from 'react';
import { Container, Row, Col, Card, ListGroup, Breadcrumb } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { categories } from '../data/categories';

const CategoryPage = () => {
  const { categoryId } = useParams();
  const category = categories.find(cat => cat.id === categoryId);

  if (!category) {
    return (
      <Container className="py-5">
        <h1>Category Not Found</h1>
        <p>The category you're looking for doesn't exist.</p>
        <Link to="/">Return to Home</Link>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
        <Breadcrumb.Item active>{category.title}</Breadcrumb.Item>
      </Breadcrumb>

      <h1 className="mb-4">{category.title}</h1>
      <p className="lead mb-5">{category.description}</p>

      <Row>
        {category.subcategories.map(subcategory => (
          <Col key={subcategory.id} md={6} lg={4} className="mb-4">
            <Card className="h-100 shadow-sm hover-card">
              <Card.Body>
                <Card.Title>{subcategory.title}</Card.Title>
                <ListGroup variant="flush" className="mb-3">
                  {subcategory.items.slice(0, 3).map(item => (
                    <ListGroup.Item key={item.id}>
                      <Link to={`/listing/${categoryId}/${subcategory.id}/${item.id}`}>
                        {item.name}
                      </Link>
                      <span className="float-end text-muted">{item.rating}/5</span>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
                <Link 
                  to={`/category/${categoryId}/${subcategory.id}`}
                  className="btn btn-outline-primary"
                >
                  View All {subcategory.title}
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default CategoryPage;
